import React from "react";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

export default function DailyTrendChart({
  records,
}) {
  const dailyMap = {};

  records.forEach((record) => {
    const day = new Date(
      record.daterecorded
    ).getDate();

    if (!dailyMap[day]) {
      dailyMap[day] = 0;
    }

    dailyMap[day] += Number(
      record.weight || 0
    );
  });

  const chartData = Object.keys(
    dailyMap
  )
    .sort((a, b) => a - b)
    .map((day) => ({
      day,
      weight: dailyMap[day],
    }));

  return (
    <div className="mt4">

      <h3 className="f3">
        Daily Collection Trend
      </h3>

      <article className="bg-white shadow-4 br3 pa3">

        <div style={{ height: 350 }}>

          <ResponsiveContainer
            width="100%"
            height="100%"
          >
            <LineChart data={chartData}>

              <CartesianGrid strokeDasharray="3 3" />

              <XAxis
                dataKey="day"
                label={{
                  value: "Day",
                  position: "insideBottom",
                }}
              />

              <YAxis
                label={{
                  value: "Weight (KG)",
                  angle: -90,
                  position: "insideLeft",
                }}
              />

              <Tooltip />

              <Line
                type="monotone"
                dataKey="weight"
                strokeWidth={3}
              />

            </LineChart>
          </ResponsiveContainer>

        </div>

      </article>

    </div>
  );
}